import React from 'react';

const styles = `
  @keyframes kp-bounce {
    0%, 80%, 100% {
      transform: translateY(0) scale(1);
      opacity: 0.4;
    }
    40% {
      transform: translateY(-14px) scale(1.15);
      opacity: 1;
    }
  }

  @keyframes kp-fade-in {
    from { opacity: 0; transform: translateY(6px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .kp-loader-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: calc(100vh - 220px);
    animation: kp-fade-in 0.3s ease forwards;
  }

  .kp-loader-wrap.fullpage {
    min-height: 100vh;
  }

  .kp-dots {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .kp-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #ED3237;
    animation: kp-bounce 1.2s ease-in-out infinite;
  }

  .kp-dot:nth-child(1) { animation-delay: 0s;    background-color: #ED3237; }
  .kp-dot:nth-child(2) { animation-delay: 0.2s;  background-color: #f97316; }
  .kp-dot:nth-child(3) { animation-delay: 0.4s;  background-color: #ED3237; }
`;

/**
 * LoadingScreen - Reusable branded loading animation.
 *
 * Props:
 *   fullPage {boolean} - Centers in full viewport height. Default: false (inline).
 *   size     {string}  - 'sm' | 'md' (default) | 'lg' — scales the dot size.
 */
function LoadingScreen({ fullPage = false, size = 'md' }) {
  const dotSize = size === 'sm' ? '8px' : size === 'lg' ? '16px' : '12px';
  const gap     = size === 'sm' ? '7px'  : size === 'lg' ? '13px' : '10px';

  return (
    <>
      <style>{styles}</style>
      <div className={`kp-loader-wrap${fullPage ? ' fullpage' : ''}`} aria-live="polite" aria-busy="true">
        <div className="kp-dots" style={{ gap }}>
          <div className="kp-dot" style={{ width: dotSize, height: dotSize }} />
          <div className="kp-dot" style={{ width: dotSize, height: dotSize }} />
          <div className="kp-dot" style={{ width: dotSize, height: dotSize }} />
        </div>
      </div>
    </>
  );
}

export default LoadingScreen;
